var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"taataa"}},[(_vm.visible)?_c('div',{class:['plugins-message-box', _vm.type]},[_c('div',{class:['message-icon', 'iconfont', _vm.iconClass]},[_c('div',{staticClass:"spantext"},[_vm._v(_vm._s(_vm.message))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }